import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { compose, branch, mapProps, withState, withHandlers, setDisplayName } from 'recompose';
import types from 'prop-types';
import _ from 'lodash';
var validated = compose(setDisplayName('behaviour(Validated)'), mapProps(function (_ref) {
  var valid = _ref.valid,
      validate = _ref.validate,
      suffix = _ref.suffix,
      validSuffix = _ref.validSuffix,
      errorSuffix = _ref.errorSuffix,
      dirty = _ref.dirty,
      _ref$__segments = _ref.__segments,
      __segments = _ref$__segments === void 0 ? {} : _ref$__segments,
      props = _objectWithoutProperties(_ref, ["valid", "validate", "suffix", "validSuffix", "errorSuffix", "dirty", "__segments"]);

  if (dirty) {
    __segments.container = (__segments.container || []).concat([valid ? 'containerValid' : 'containerError']);
  }

  return _objectSpread({}, props, {
    __segments: __segments,
    suffix: dirty && (validSuffix || errorSuffix) ? valid ? validSuffix : errorSuffix : suffix
  });
}));
var uncontrolled = compose(setDisplayName('behaviour(Validated(Uncontrolled))'), withState('dirty', 'setDirty', false), withState('valid', 'setValid', false), withHandlers({
  onChange: function onChange(_ref2) {
    var setValid = _ref2.setValid,
        _ref2$validate = _ref2.validate,
        validate = _ref2$validate === void 0 ? _.noop : _ref2$validate,
        _ref2$onChange = _ref2.onChange,
        _onChange = _ref2$onChange === void 0 ? _.noop : _ref2$onChange;

    return function (e) {
      _onChange(e);

      !e.defaultPrevented && setValid(validate(e.target.value));
    };
  },
  onBlur: function onBlur(_ref3) {
    var setDirty = _ref3.setDirty,
        dirty = _ref3.dirty,
        _ref3$onBlur = _ref3.onBlur,
        _onBlur = _ref3$onBlur === void 0 ? _.noop : _ref3$onBlur;

    return function (e) {
      _onBlur(e);

      if (!e.defaultPrevented && !dirty) setDirty(true);
    };
  }
}), mapProps(function (_ref4) {
  var setDirty = _ref4.setDirty,
      setValid = _ref4.setValid,
      props = _objectWithoutProperties(_ref4, ["setDirty", "setValid"]);

  return props;
}), validated);
var notValidated = compose(setDisplayName('behaviour(NotValidated)'), mapProps(function (_ref5) {
  var validSuffix = _ref5.validSuffix,
      errorSuffix = _ref5.errorSuffix,
      valid = _ref5.valid,
      props = _objectWithoutProperties(_ref5, ["validSuffix", "errorSuffix", "valid"]);

  return props;
}));
export default compose(branch(function (_ref6) {
  var uncontrolled = _ref6.uncontrolled,
      validate = _ref6.validate;
  return uncontrolled && _.isFunction(validate);
}, uncontrolled, branch(function (_ref7) {
  var dirty = _ref7.dirty;
  return _.isBoolean(dirty);
}, validated, notValidated)));
export var propTypes = {
  validate: types.func,
  valid: types.bool,
  dirty: types.bool,
  validSuffix: types.oneOfType([types.element, types.string]),
  errorSuffix: types.oneOfType([types.element, types.string])
};